module.exports = __webpack_public_path__ + "static/media/Ecofric_Logo_Grønn.15091d9c.zip";